export default "https://cdn-static.gokick.com/assets/81b7a47639310ad105c767144326fc68b25cbb5d/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";